<template>
  <CModal :show.sync="isOpenModal" addContentClasses="px-4 py-4" :closeOnBackdrop="false">
    <template #header-wrapper>
      <h5>{{ $t('automation.date.new.modal.title') }}</h5>
    </template>
    <template #body-wrapper>
      <div class="py-5">
        <AutomationForm ref="form" :isBirthDate="isBirthdate" v-if="reloadForm" :statingPointList="dateFieldsList" :loading="loading" />
      </div>
    </template>
    <template #footer-wrapper>
      <div class="text-right">
        <CButton class="px-4 py-2 mr-3" color="white" @click="cancelClick()" :disabled="loading">
          {{ $t('automation.date.new.modal.button.cancel') }}
        </CButton>
        <CButton class="px-4 py-2" color="primary" @click="submitForm()" :disabled="loading">
          <CSpinner v-if="loading" class="mr-1 align-middle" style="width: 1rem; height: 1rem" />
          {{ $t('automation.date.new.modal.button.start') }}
        </CButton>
      </div>
    </template>
  </CModal>
</template>
<script>
import AutomationForm from './AutomationForm.vue'
import { TRIGGER_TYPES } from '../constants'
import services from '@/services.js'

export default {
  name: 'AutomationNewModal',
  components: { AutomationForm },
  props: {
    dateFieldsList: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {},
  data() {
    return {
      isOpenModal: false,
      reloadForm: true,
      isBirthdate: false,
      loading: false,
    }
  },
  methods: {
    openModal(isBirthdate) {
      this.loading = false
      this.isOpenModal = true
      this.isBirthdate = isBirthdate
      // Recarregar o form
      this.reloadForm = false
      this.$nextTick(() => (this.reloadForm = true))
    },
    cancelClick() {
      this.isOpenModal = false
    },
    validateForm() {
      return this.$refs.form.validateForm()
    },
    getForm() {
      return this.$refs.form.getForm()
    },
    submitForm() {
      if (this.validateForm()) {
        this.loading = true
        let organizationId = this.$route.params.organizationId
        let form = this.getForm()
        let workflow = {
          // id: null, // ainda não criado
          triggers: {
            values: [
              {
                type: TRIGGER_TYPES.DATE,
                data: form.triggerData,
              },
            ],
          },
          steps: {
            values: [],
          },
        }
        let params = {
          organizationId: organizationId,
          name: form.name,
          workflowJson: JSON.stringify(workflow),
          beginDateTime: new Date(),
          endDateTime: new Date(),
        }

        services
          .postAutomation(organizationId, params)
          .then((res) => {
            return this.$router.push({ name: 'automationWorkflow', params: { workflowId: res.data.data.id } })
          })
          .catch((err) => {
            console.log(err.response.data)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>
<style lang="scss">
.comment-text {
  color: $gray-400;
  font-size: $font-size-xs;
}
</style>
